import React from 'react';
const SvgChevronLeft = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { d: "M22.857 32l-16-16 16-16 2.9 2.91L12.677 16l13.08 13.09z", fillRule: "evenodd" })));
export default SvgChevronLeft;
//# sourceMappingURL=ChevronLeft.js.map